/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankEmployee from './blood-bank-employee';
import BloodBankEmployeeDetail from './blood-bank-employee-detail';
import BloodBankEmployeeUpdate from './blood-bank-employee-update';
import BloodBankEmployeeDeleteDialog from './blood-bank-employee-delete-dialog';

const BloodBankEmployeeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankEmployee />} />
    <Route path="new" element={<BloodBankEmployeeUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankEmployeeDetail />} />
      <Route path="edit" element={<BloodBankEmployeeUpdate />} />
      <Route path="delete" element={<BloodBankEmployeeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankEmployeeRoutes;
